import {useGlp1Modality} from 'surveys/osa_funnel/hooks/useGlp1Modality';
import {Glp1EducationLegitimacyBranded} from './Glp1EducationLegitimacyBranded';
import {Glp1EducationLegitimacyCompounded} from './Glp1EducationLegitimacyCompounded';

export const Glp1EducationLegitimacy = () => {
  const modality = useGlp1Modality();
  return modality === 'compounded_v1' ? <Glp1EducationLegitimacyCompounded /> : <Glp1EducationLegitimacyBranded />;
};

export default Glp1EducationLegitimacy;
